module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Bhk6Gf/Images/cover.jpg?1685327250323",
      "alt": "This image is the cover for the book Colors"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Colors\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("High school senior Neil Darrien is a budding musical theater star. He has it all—a beautiful girlfriend, a scholarship at a prestigious school, and plenty of chances to showcase his talent. But when Zane Jeffrey comes to town and immediately lands a spot in the school show choir, Neil is jealous. What Neil didn’t count on, though, is Zane’s charm and humor, and the two soon become friends.")]), _vm._v(" "), _c('p', [_vm._v("Melissa, Neil’s girlfriend, notices Zane monopolizing Neil and draws Neil into her church. There Neil discovers a situation he knows he needs to fix, but if he does, a deep, dark secret that could cost him his future career might come out.")]), _vm._v(" "), _c('p', [_vm._v("When his relationship with Melissa becomes rocky, Neil is drawn to Zane in a way that is more than friendship.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Russell J. Sanders\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0